/**
 * Cross-visit "continue listening" persistence for series pages.
 *
 * One localStorage entry per series page path holding { guid, position, updatedAt }.
 * The guid identifies the episode (matches item.guid / item['ifl:guid'] from
 * SeriesJSON) and position is the playback offset in whole seconds.
 *
 * All localStorage access is wrapped in try/catch because it can throw (Safari
 * private browsing, storage disabled, quota exceeded). When storage is
 * unavailable, resume silently degrades to the old behavior of starting at the
 * first episode.
 */

const KEY_PREFIX = 'broadcastPlayerResume:';

export function getResumeKey() {
    return KEY_PREFIX + window.location.pathname;
}

export function loadResumeState(key) {
    if (!key) return null;
    try {
        const raw = window.localStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
        return null;
    }
}

export function saveResumeState(key, state) {
    if (!key) return;
    try {
        window.localStorage.setItem(key, JSON.stringify({ ...state, updatedAt: Date.now() }));
    } catch (e) {
        // Storage unavailable — resume is a best-effort enhancement.
    }
}

export function clearResumeState(key) {
    if (!key) return;
    try {
        window.localStorage.removeItem(key);
    } catch (e) {
        // Ignore: nothing to clean up if storage is unavailable.
    }
}
